import React from 'react';
import { extensionTag } from '../utils/documentFormatters';

const PreviewFallbackIcon = ({ filename }) => (
  <div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-bg-gray-50">
    <span className="mi-file-text-outline tw-text-3xl tw-text-gray-400" />
    <span className="tw-rounded-full tw-bg-gray-200 tw-px-2.5 tw-py-0.5 tw-text-[10px] tw-font-semibold tw-text-gray-600">
      {extensionTag(filename)}
    </span>
  </div>
);

export default PreviewFallbackIcon;
